import { times, divide, minus } from 'number-precision'
import { calculateOdds, getPrecision } from 'utils/common-functions/index'
import { MAX_MINE_COUNT, MAX_TILE_COUNT } from '../mineGame.constants'

export const calculateMineGameCashoutOdds = (mineCount = 0, openedTileCount = 0, gameSettings) => {
  let combinedOdds = 1

  for (let index = 0; index < openedTileCount; index++) {
    const probability = divide(1, divide((minus(minus(MAX_TILE_COUNT, mineCount), index)), minus(MAX_TILE_COUNT, index)))
    combinedOdds = times(combinedOdds, probability)
  }

  return calculateOdds({ odds: combinedOdds, ...gameSettings })
}

export const mines = Array.from({ length: MAX_MINE_COUNT }, (_, i) => i + 1)
export const customMines = Array.from({ length: MAX_MINE_COUNT }, (_, i) => ({
  key: i + 1,
  value: i + 1
}));